export default __webpack_public_path__ + "static/media/svg-5.abac5156.svg";